import { Button } from '@mui/material';
import { useXeroConnect } from '../../../../../../hooks/requests/use-xero-connect';
import { runMutation } from '../../../../../../utils/vy-mutation';
import type { XeroRegisterFormControl } from './XeroRegisterFormSchema';

interface Props {
  control: XeroRegisterFormControl;
}

export const XeroRegistrationFooter = ({ control }: Props) => {
  const connectXeroMutation = useXeroConnect();
  const { handleSubmit } = control;

  const submitHandler = handleSubmit(async (formValues) => {
    await runMutation(connectXeroMutation, formValues, {
      pending: 'Connecting...',
      success: 'Redirecting...',
      error: 'Failed to connect',
    });
  });

  return (
    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Button variant="contained" onClick={submitHandler}>
        Connect to Xero
      </Button>
    </div>
  );
};
